import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DsButtonModule, DsLinkModule, DsMessageModule } from '@bmw-ds/components';

import { Role } from '../../auth/roles';
import { AuthorizationWrapper } from '../authorization/authorization.wrapper';
import { HeaderContainer } from '../header/components/header.container';
import { WebComponentDirective } from '../web-component/web-component.directive';
import { ReportingPage } from './reporting.page';

@Component({
  selector: 'cdf-reporting-web-component',
  imports: [HeaderContainer, AuthorizationWrapper, DsButtonModule, DsMessageModule, DsLinkModule, ReportingPage],
  template: `
    <cdf-header />

    <cdf-authorization-wrapper [allowedRoles]="allowedRoles" skipWhitelistCheck>
      <cdf-reporting />
    </cdf-authorization-wrapper>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportingWebComponent extends WebComponentDirective {
  protected readonly allowedRoles = [Role.CDF_REPORTING] as const;
}
